<template>
<div>
  <v-container style="max-width: 500px">
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <v-layout column>
              <v-flex xs12>
                <v-layout row>
                  <h2>Status for {{Date.now() | momentDay}}</h2>
                  <v-spacer></v-spacer>
                  <v-btn round color="info" @click.stop="sheet = true">
                    <v-icon left>filter_list</v-icon>Filter
                  </v-btn>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-data-table :headers="dataHeaders" :items="dataTable" :search="search" v-bind:pagination.sync="pagination" :loading="!dataReady">
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <div v-if="showTime">
                <td v-if="props.item.status === 'No activity'" class="text-xs-right">{{ props.item.time | momentDay }}</td>
                <td v-else class="text-xs-right">{{ props.item.time | moment }}</td>
              </div>
              <td class="text-xs-right">
                <v-chip :class="chipColor(props.item.status)">{{ props.item.status }}</v-chip>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
  <v-bottom-sheet v-model="sheet" value="1">
    <v-container class="white">
      <h1>Filter List</h1>
      <v-divider></v-divider>
      <v-layout row align-center justify-space-around>
        <v-flex xs2>
          <v-icon large>how_to_reg</v-icon>
        </v-flex>
        <v-flex xs4>
          <h2>Active Today</h2>
        </v-flex>
        <v-flex xs2>
          <v-switch
            v-model="activitySwitch"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout row align-center justify-space-around>
        <v-flex xs2>
          <v-icon large>home</v-icon>
        </v-flex>
        <v-flex xs4>
          <h2>Onsite only</h2>
        </v-flex>
        <v-flex xs2>
          <v-switch
            v-model="onsiteSwitch"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout row align-center justify-space-around>
        <v-flex xs2>
          <v-icon large>book</v-icon>
        </v-flex>
        <v-flex xs4>
          <h2>Hide Unassigned Cards</h2>
        </v-flex>
        <v-flex xs2>
          <v-switch
            v-model="unassignedSwitch"
          ></v-switch>
        </v-flex>
      </v-layout>
      <v-layout row align-center justify-space-around>
        <v-flex xs2>
          <v-icon large>calendar_today</v-icon>
        </v-flex>
        <v-flex xs4>
          <h2>Show time of last update</h2>
        </v-flex>
        <v-flex xs2>
          <v-switch
            v-model="showTime"
          ></v-switch>
        </v-flex>
      </v-layout>
    </v-container>
  </v-bottom-sheet>
</div>
</template>

<script>
import moment from "moment";
import {
  db
} from "@/main.js";
export default {
  data() {
    return {
      dataReady: false,
      search: "",
      users: [],
      pagination: {
        rowsPerPage: 25
      },
      headers: [{
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Updated",
          align: "left",
          value: "time"
        },
        {
          text: "Status",
          align: "right",
          value: "status"
        }
      ],
      sheet: false,
      // Filters
      showTime: false,
      activitySwitch: false,
      onsiteSwitch: false,
      unassignedSwitch: true
    };
  },
  methods: {
    chipColor(status) {
      let color = "grey";
      switch (status) {
        case "Offsite":
          color = "green";
          break;
        case "Onsite, via Gate 2":
          color = "orange";
          break;
        case "Onsite, via Gate 3":
          color = "orange";
          break;
      }
      return color;
    },
    chooseDateFilter(status) {
      if (status === "No activity") {
        return this.moment;
      } else {
        return this.momentDay;
      }
    },
    filterList(person) {
      if (person.hideOnMainScreen) {
        return false
      }
      if (this.activitySwitch) {
        if(person.status === "No activity"){
          return false
        }
      } else if (this.onsiteSwitch) {
        if(person.status !== "Onsite, via Gate 3" && person.status !== "Onsite, via Gate 2"){
          return false
        }
      } else if(this.unassignedSwitch) {
        if(person.name.length === 1) {
          return false
        }
      }
      return true
    }
  },
  computed: {
    dataHeaders() {
      if (this.showTime) {
        return [{
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Updated",
          align: "left",
          value: "time"
        },
        {
          text: "Status",
          align: "right",
          value: "status"
        }
      ]
      } else {
        return [{
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Status",
          align: "right",
          value: "status"
        }
      ]
      }
    },
    dataTable() {
      let data = [];
      if (this.users !== null) {
        this.users.forEach(u => {
          if ("status" in u) {
            const now = new Date();
            let obj = {
              name: `${u.firstName} ${u.lastName}`,
              time: u.updatedAt.toDate(),
              status: "No activity",
              hideOnMainScreen: false
            };
            if('hideOnMainScreen' in u) {
              obj.hideOnMainScreen = u.hideOnMainScreen
            }
            if (u.updatedAt.toDate().getDate() === now.getDate()) {
              obj.status = u.status
            }
            if(this.filterList(obj)) {
              data.push(obj)
            }
          }
        });
      }
      return data;
    }
  },
  mounted() {
    this.$bind("users", db.collection("users").orderBy("lastName"))
      .then(doc => {
        this.dataReady = true;
      })
      .catch(error => {
        console.log("error in loading: ", error);
      });
  },
  filters: {
    moment: date => {
      return moment(date).format("h:mm:ss a");
    },
    momentDay: date => {
      return moment(date).format("MMMM Do YYYY");
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue